import { Button, FoodsIcon, Typography } from "@foodpilot/foods";
import { Box, Chip, Stack, dividerClasses, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router";
import { ActiveOrganizationContextHeader } from "src/components/ActiveOrganizationContextHeader";

type WhiteLayoutProps = {
    children: ReactNode;
    title: string;
    chipContent?: string;
    subtitleLink: {
        label: string;
        goTo: string;
    };
};
export const WhiteLayout = (props: WhiteLayoutProps) => {
    const { children, title, chipContent, subtitleLink } = props;
    const theme = useTheme();
    return (
        <Stack>
            <Box sx={{ background: theme.palette.background.paper, display: "flex", justifyContent: "space-between" }}>
                <Stack padding={{ xs: theme.spacing(6, 2), sm: theme.spacing(2, 6) }} width="100%" minWidth={0} gap={2}>
                    <Stack
                        flexDirection={"row"}
                        justifyContent={{ xs: "center", md: "flex-start" }}
                        alignItems={"center"}
                        flex={{ xs: 1, lg: 1 }}
                        minWidth={0}
                    >
                        <ActiveOrganizationContextHeader
                            sx={{
                                flexDirection: { xs: "column", md: "row" },
                                width: "100%",
                                maxWidth: "100%",
                                justifyContent: { xs: "center", md: "flex-start" },
                                gap: { xs: 0.5, md: 2 },
                            }}
                            titleSx={{
                                width: { xs: "100%", md: "auto" },
                                flexWrap: "wrap",
                                justifyContent: { xs: "center", md: "flex-start" },
                                gap: 1,
                                maxWidth: "100%",
                                textAlign: { xs: "center", md: "left" },
                            }}
                            contextRowSx={{
                                justifyContent: "center",
                                maxWidth: "100%",
                                [`& .${dividerClasses.root}`]: { display: { xs: "none", md: "block" } },
                            }}
                            contextSx={{ maxWidth: "100%" }}
                            labelSx={{
                                maxWidth: "100%",
                                whiteSpace: "normal",
                                overflow: "visible",
                                textOverflow: "clip",
                                overflowWrap: "anywhere",
                                textAlign: { xs: "center", md: "left" },
                            }}
                            title={
                                <>
                                    <Box minWidth={0} maxWidth="100%" sx={{ overflowWrap: "anywhere" }}>
                                        <Typography variant="h1">{title}</Typography>
                                    </Box>
                                    {chipContent !== undefined && (
                                        <Chip
                                            label={chipContent}
                                            color="primary"
                                            variant="filled"
                                            sx={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                py: 0.5,
                                                "& .MuiChip-label": { whiteSpace: "normal", overflowWrap: "anywhere" },
                                            }}
                                        />
                                    )}
                                </>
                            }
                        />
                    </Stack>
                    <Stack
                        flexDirection={"row"}
                        justifyContent={{ xs: "center", md: "flex-start" }}
                        alignItems={"center"}
                    >
                        <Link to={subtitleLink.goTo}>
                            <Button
                                variant="text"
                                startIcon={<FoodsIcon size={2} icon={"arrowLeft"} />}
                                sx={{ whiteSpace: "normal", maxWidth: "100%" }}
                            >
                                {subtitleLink.label}
                            </Button>
                        </Link>
                    </Stack>
                </Stack>
            </Box>
            <Stack px={{ xs: 2, sm: 6 }} pt={3} bgcolor={theme.custom.grey[300]}>
                {children}
            </Stack>
        </Stack>
    );
};
